import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
// import Select from 'react-select';
import { Field, change } from 'redux-form';
import { formValueSelector } from 'redux-form';
import { createSelector } from 'reselect';

// import helpers from './helpers';
import InputField from '../../form/InputField';

import { ElementTypeActions } from '../../../actions/elementType';
import { RelationshipTypeActions } from '../../../actions/relationshipType';
import { currentProjectIdSelector } from '../../../reducers/projects';
import {
  elementsSelector,
  currentElementIdSelector,
} from '../../../reducers/elements';
import {
  shouldLoadElementTypesSelector,
  elementTypesSelector,
} from '../../../reducers/elementTypes';
import {
  shouldLoadRelationshipTypesSelector,
  relationshipTypesSelector,
} from '../../../reducers/relationshipTypes';
import '../../../styles/ReactSelect.css';

const FormSelector = (state, props) => {
  const selector = formValueSelector(props.form || props.uid);
  return selector(state, 'typeOptions', 'propValue');
};

const DesignerSelector = createSelector(
  [
    currentProjectIdSelector,
    shouldLoadRelationshipTypesSelector,
    shouldLoadElementTypesSelector,
    currentElementIdSelector,
    FormSelector,
    elementTypesSelector,
    relationshipTypesSelector,
    elementsSelector,
  ],
  (
    currentProjectId,
    shouldLoadRelationshipTypes,
    shouldLoadElementTypes,
    currentElementId,
    DesignerForm,
    elementTypes,
    relationshipTypes,
    elements,
  ) => ({
    currentProjectId,
    shouldLoadRelationshipTypes,
    shouldLoadElementTypes,
    currentElementId,
    fields: DesignerForm,
    elementTypes,
    relationshipTypes,
    elements,
  }),
);

@connect(DesignerSelector)
export default class Designer extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    currentElementId: PropTypes.string,
    dispatch: PropTypes.func,
    elements: PropTypes.object,
    elementTypes: PropTypes.object,
    fields: PropTypes.object,
    input: PropTypes.object,
    labelClassName: PropTypes.string,
    relationshipTypes: PropTypes.object,
    uid: PropTypes.string,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  componentDidMount = () => {
    const {
      dispatch,
      currentProjectId,
      shouldLoadRelationshipTypes,
      shouldLoadElementTypes,
    } = this.props;
    if (shouldLoadElementTypes) {
      dispatch(ElementTypeActions.getProjectElementTypes(currentProjectId));
    }
    if (shouldLoadRelationshipTypes) {
      dispatch(
        RelationshipTypeActions.getProjectRelationshipTypes(currentProjectId),
      );
    }
  };

  setListOptions = value => {
    if (typeof value === 'string') {
      return value.split(',');
    }
    return value;
  };

  objToString = o => {
    if (Array.isArray(o)) {
      return o.join(',');
    } else if (typeof o === 'object') {
      const keys = Object.keys(o);
      const list = [];

      keys.forEach(e => {
        const value = o[e];
        if (typeof value === 'string') {
          list.push(value);
        }
      });
      return list.join('');
    }
    return o;
  };

  populateTypeOptions = () => {
    const { elementTypes } = this.props;
    const output = [];

    elementTypes.forEach(o => {
      const value = o.get('type');
      const id = o.get('id');

      output.push({
        label: value,
        value: id,
      });
    });

    return output;
  };

  populateRelTypeOptions = () => {
    const { relationshipTypes } = this.props;
    const output = [];

    relationshipTypes.forEach(o => {
      const value = o.get('type');
      const id = o.get('id');

      output.push({
        label: value,
        value: id,
      });
    });

    return output;
  };

  populateRelDirectionOptions = () => {
    const output = [];

    output.push({
      label: 'Consumes From',
      value: 'consumesFrom',
    });
    output.push({
      label: 'Provides To',
      value: 'providesTo',
    });

    return output;
  };

  handleDesignerOnChangeMultiRel = value => {
    const {
      dispatch,
      fields: { typeOptions },
      uid,
    } = this.props;

    let newTypeOptions = typeOptions;

    if (!newTypeOptions) {
      newTypeOptions = {};
    }

    let isMultiRel;
    if (value && value.target) {
      isMultiRel = value.target.checked;
      // console.log('isMultiRel: ', isMultiRel);
    }

    newTypeOptions.multi_relationship = isMultiRel;
    // newTypeOptions['multi_relationship'] = isMultiRel;

    const elmTypes = newTypeOptions['[ET]element_type'];
    const typeObjElmTypes = typeof elmTypes;

    if (typeObjElmTypes === 'string') {
      if (!isMultiRel) {
        const hasComma = elmTypes.indexOf(',');
        if (hasComma !== -1) {
          const list = elmTypes.split(',');
          if (list.length >= 1) {
            newTypeOptions['[ET]element_type'] = list[0];
          }
        }
      }
    }

    dispatch(change(uid, 'typeOptions', newTypeOptions));
  };

  handleDesignerOnChangeElmType = value => {
    const {
      dispatch,
      fields: { typeOptions },
      uid,
    } = this.props;

    // const value2 = this.objToString(value);
    const value2 = value;

    const theValue = this.setListOptions(value2);

    let newTypeOptions = typeOptions;

    if (!newTypeOptions) {
      newTypeOptions = {};
    }

    newTypeOptions['[ET]element_type'] = theValue;

    dispatch(change(uid, 'typeOptions', newTypeOptions));
  };

  handleDesignerOnChangeRelType = value => {
    const {
      dispatch,
      fields: { typeOptions },
      uid,
    } = this.props;

    let theValue = value;

    theValue = this.objToString(theValue);

    let newTypeOptions = typeOptions;

    if (!newTypeOptions) {
      newTypeOptions = {};
    }

    newTypeOptions['[RT]relationship_type'] = theValue;

    dispatch(change(uid, 'typeOptions', newTypeOptions));
  };

  handleDesignerOnChangeRelDirection = value => {
    const {
      dispatch,
      fields: { typeOptions },
      uid,
    } = this.props;

    let theValue = value;
    theValue = this.objToString(theValue);

    let newTypeOptions = typeOptions;

    if (!newTypeOptions) {
      newTypeOptions = {
        relationship_direction: theValue,
      };
    } else {
      newTypeOptions.relationship_direction = theValue;
      // newTypeOptions['relationship_direction'] = theValue;
    }

    dispatch(change(uid, 'typeOptions', newTypeOptions));
  };

  render = () => {
    const {
      containerClassName,
      containerStyle,
      currentElementId,
      // elements,
      // input,
      labelClassName,
      fields: { typeOptions },
      wrapperClassName,
      wrapperStyle,
    } = this.props;

    // console.log('In Designer: ', this.props);
    const isMultiRel = (typeOptions && typeOptions.multi_relationship) ? true : false;  // eslint-disable-line
    const options = this.populateTypeOptions();
    const relOptions = this.populateRelTypeOptions();

    const designer =
      (<div>
        <div className={wrapperClassName} style={wrapperStyle}>
          <label
            htmlFor="typeOptions['multi_relationship']"
            className={labelClassName}
          >
            Multi Relationships
          </label>
          <div className={containerClassName} style={containerStyle}>
            <Field
              name="typeOptions['multi_relationship']"
              type="checkbox"
              className="mt-2"
              component={InputField}
              onChange={e => {
                this.handleDesignerOnChangeMultiRel(e);
              }}
              currentElementId={currentElementId}
            />
          </div>
        </div>

        <div className={wrapperClassName} style={wrapperStyle}>
          <label
            htmlFor="typeOptions['[ET]element_type']"
            className={labelClassName}
          >
            Element Types
          </label>
          <div className={containerClassName} style={containerStyle}>
            <Field
              name="typeOptions['[ET]element_type']"
              type={isMultiRel ? 'multi-select' : 'single-select'}
              component={InputField}
              className="form-control"
              style={{ width: '100%', marginBottom: 10 }}
              // normalize={this.normalizeListOptions}
              options={options}
              onChange={e => {
                this.handleDesignerOnChangeElmType(e);
              }}
              currentElementId={currentElementId}
            />
          </div>
        </div>

        <div className={wrapperClassName} style={wrapperStyle}>
          <label
            htmlFor="typeOptions['[RT]relationship_type']"
            className={labelClassName}
          >
            Relationship Type
          </label>
          <div className={containerClassName} style={containerStyle}>
            <Field
              name="typeOptions['[RT]relationship_type']"
              type="single-select"
              component={InputField}
              className="form-control"
              style={{ width: '100%', marginBottom: 10 }}
              // normalize={this.setListOptions}
              options={relOptions}
              onChange={e => {
                this.handleDesignerOnChangeRelType(e);
              }}
              currentElementId={currentElementId}
            />
          </div>
        </div>

        <div className={wrapperClassName} style={wrapperStyle}>
          <label
            htmlFor="typeOptions.relationship_direction"
            className={labelClassName}
          >
            Relationship Direction
          </label>
          <div className={containerClassName} style={containerStyle}>
            <Field
              name="typeOptions.relationship_direction"
              type="single-select"
              component={InputField}
              className="form-control"
              style={{ width: '100%', marginBottom: 10 }}
              options={this.populateRelDirectionOptions()}
              onChange={e => {
                this.handleDesignerOnChangeRelDirection(e);
              }}
            />
          </div>
        </div>

        {/* <div className={wrapperClassName} style={wrapperStyle}>
          {defaultValue}
          <div className={containerClassName} style={containerStyle}>
            <Select
              ref={input1 => {
                this.theInput = input1;
              }}
              multi={isMultiRel}
              simpleValue
              autoBlur
              joinValues
              clearable={false}
              searchable
              matchProp={'label'}
              matchPos={'any'}
              onBlurResetsInput={false}
              onCloseResetsInput={false}
              onBlurSelectsFocusedOption
              backspaceRemoves={false}
              cache={false}
              style={{ display: 'inline-block', height: 'auto' }}
              {...input}
              // value={selectedValues}
              options={defOptions}
              onBlur={() => {
                this.theInput.closeMenu();
              }}
            />
          </div>
        </div> */}

        <div />
      </div>);
    return designer;
  };
}



// WEBPACK FOOTER //
// ./src/components/types/RelationshipSelect/Designer.js